import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  productInfo: {
    marginTop: 40,
  },
  productName: {
    marginTop: 50,
  },
  price: {
    marginLeft: 250,
    marginTop: 180,
  },
  addCart: {
    marginTop: 50,
  },
  cartProductInfo: {
    marginTop: 40,
  },
  review: {
    marginLeft: -15,
  },
  textReview: {
    marginLeft: 20,
    marginRight: "auto",
    fontWeight: "bold",
  },
  divider: {
    maxWidth: 700,
    marginTop: 20,
    marginBottom: 15,
  },
  cursor: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  customerReview: {
    fontWeight: "bold",
    marginTop: 50,
  },
  reviewLength: {
    marginLeft: 5,
  },
  reviewWidth: {
    maxWidth: 700,
  },
  icon: {
    paddingTop: 10,
    marginLeft: 5,
  },
  overview: {
    maxWidth: 1150,
    fontSize: 18,
  },
  overviewDivider: {
    maxWidth: 1150,
    marginTop: 20,
    marginBottom: 20,
  },
  image: {
    marginTop: 50,
  },
});
